var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuthRightBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 747,
    height: 341,
    viewBox: "0 0 747 341",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M574.388 237.168L1202.52 158.626V254.342L574.388 332.884V237.168Z",
    fill: "#1996A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.54576 245.04L914.862 95.8312L918.461 191.479L8.14511 340.689L4.54576 245.04Z",
    fill: "#FAB54E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M432.161 78.5336L1060.3 -0.00878906V95.7071L432.161 174.25V78.5336Z",
    fill: "#1467B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthRightBg);
export default __webpack_public_path__ + "static/media/AuthRightBg.9ff366970c65cc9f145bdda4998c9c07.svg";
export { ForwardRef as ReactComponent };